import { useEffect, useState } from "react";

const useOnlineStatus = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOffline = () => setIsOnline(false);

		window.addEventListener("offline", handleOffline);

		return () => {
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	if (!isOnline) {
		throw new Error("No internet connection");
	}
};

export default useOnlineStatus;
